import React__default, { Component } from 'react';
import { __extends } from '../../_virtual/_tslib.js';
import { isAfter } from 'date-fns';
import withChat from '../Provider/withChat.js';
import { MessageChannel } from '@deal/chat-firebase-client';
import Exchange$1 from '../../components/Exchange/index.js';
import MessageGroup from '../../components/MessageGroup/index.js';
import Message from '../Message/index.js';

var ExchangeContainer =
/** @class */
function (_super) {
  __extends(ExchangeContainer, _super);

  function ExchangeContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.getChannelsForMessage = _this.getChannelsForMessage.bind(_this);
    _this.getChannelsForGroup = _this.getChannelsForGroup.bind(_this);
    _this.isConversationMessage = _this.isConversationMessage.bind(_this);
    _this.getMessages = _this.getMessages.bind(_this);
    _this.getNextMessage = _this.getNextMessage.bind(_this);
    _this.getNextMessageBySameParticipant = _this.getNextMessageBySameParticipant.bind(_this);
    _this.getSenderForConversationItem = _this.getSenderForConversationItem.bind(_this);
    return _this;
  }
  /**
   * Get the messaging channels (sms, email, facebook, etc.) used to send a single message.
   */


  ExchangeContainer.prototype.getChannelsForMessage = function (message) {
    switch (message.sentVia) {
      case MessageChannel.EMAIL:
        return new Set([MessageChannel.EMAIL]);

      case MessageChannel.FACEBOOK:
        return new Set([MessageChannel.FACEBOOK]);

      case MessageChannel.SMS:
        return new Set([MessageChannel.SMS]);
    }

    return new Set();
  };
  /**
   * Get the messaging channels (sms, email, facebook, etc.) used to send a group of messages.
   */


  ExchangeContainer.prototype.getChannelsForGroup = function (group) {
    var _this = this;

    var channels = new Set();
    group.forEach(function (conversationItem) {
      conversationItem.type === 'Message' && _this.getChannelsForMessage(conversationItem.message).forEach(function (channel) {
        channels.add(channel);
      });
    });
    return channels;
  };

  ExchangeContainer.prototype.isConversationMessage = function (item) {
    return item.type === 'Message';
  };
  /**
   * Return all the FirebaseMessages in this exchange's items
   *
   * TODO: memoization
   */


  ExchangeContainer.prototype.getMessages = function () {
    return this.props.items.filter(this.isConversationMessage).map(function (item) {
      return item.message;
    });
  };
  /**
   * Given a FirebaseMessage, determine the next message in the conversation.
   */


  ExchangeContainer.prototype.getNextMessage = function (message) {
    var messages = this.getMessages();
    var currentMessageIndex = messages.findIndex(function (m) {
      return m.messageId === message.messageId;
    });
    return messages[currentMessageIndex - 1];
  };
  /**
   * Given a FirebaseMessage, determine the next message sent by the same participant.
   */


  ExchangeContainer.prototype.getNextMessageBySameParticipant = function (message) {
    // Filter out messages from other participants
    var myMessages = this.getMessages().filter(function (message) {
      return message.sentBy.isMyself;
    });
    var currentMessageIndex = myMessages.findIndex(function (m) {
      return m.messageId === message.messageId;
    });
    return myMessages[currentMessageIndex - 1];
  };

  ExchangeContainer.prototype.getSenderForConversationItem = function (item) {
    if (item.type === 'Message' && this.props.showRealSender) {
      return item.message.realSender;
    } else if (item.type === 'Message') {
      return item.message.sentBy;
    } else {
      return undefined;
    }
  };

  ExchangeContainer.prototype.getCampaignForAutoMessage = function (message) {
    for (var _i = 0, _a = message.parts; _i < _a.length; _i++) {
      var part = _a[_i];
      return part.body && part.body.tracking && part.body.tracking.campaign || undefined;
    }
  };

  ExchangeContainer.prototype.isConversationItemAutoMessage = function (item) {
    if (item.type === 'Message') {
      // We only started including "richCardType" after April 2019. Rich card messages before
      //   then will not be distinguishable from auto messages.
      var isAfterApril2019 = isAfter(item.message.sentAt.toDate(), new Date('2019-04-01T00:00:00.000Z'));
      return isAfterApril2019 && item.message.parts.some(function (part) {
        return part.type === 'TEMPLATE_CAROUSEL' && !part.body.hasOwnProperty('richCardType');
      });
    } else {
      return false;
    }
  };

  ExchangeContainer.prototype.render = function () {
    var _this = this;
    /**
     * Chunk this exchange of messages into messages sent by the same user ("message groups").
     *
     * If the viewer is not a consumer, we also create distinct groups for auto messages vs real messages.
     *
     * This logic requires the messages to be sorted.
     */


    var groups = this.props.items.reduce(function (accumulatedGroups, current, index, messages) {
      var previous = messages[index - 1];

      var currentSender = _this.getSenderForConversationItem(current);

      var prevSender = previous && _this.getSenderForConversationItem(previous);

      var currentSenderId = currentSender && currentSender.userId;
      var prevSenderId = prevSender && prevSender.userId;

      var currentIsAutoMessage = _this.isConversationItemAutoMessage(current);

      var prevIsAutoMessage = previous && _this.isConversationItemAutoMessage(previous); // We only want to distinguish between auto messages and real messages for non-consumers


      var isMyselfConsumer = _this.props.chatClient && _this.props.chatClient.myself.type === 'USER';

      if (!previous || currentSenderId !== prevSenderId || !isMyselfConsumer && currentIsAutoMessage !== prevIsAutoMessage) {
        accumulatedGroups.push([]);
      }

      accumulatedGroups[accumulatedGroups.length - 1].push(current);
      return accumulatedGroups;
    }, []);

    if (!this.props.items.length) {
      return null;
    }

    return React__default.createElement(Exchange$1, {
      startedAt: this.props.items[this.props.items.length - 1].time
    }, groups.map(function (group, idx) {
      var channels = Array.from(_this.getChannelsForGroup(group));
      var lastItem = group[group.length - 1];
      var firstMessage = group.find(function (group) {
        return group.type === 'Message';
      });
      var autoMessage = firstMessage ? _this.isConversationItemAutoMessage(firstMessage) : false;
      var sender = firstMessage && _this.getSenderForConversationItem(firstMessage) || null;
      var persona = !sender ? null : _this.props.showRealSender && firstMessage && firstMessage.type === 'Message' && firstMessage.message.sentBy.userId !== sender.userId ? firstMessage.message.sentBy.displayName : null;
      return React__default.createElement(MessageGroup, {
        sender: sender,
        sentAt: firstMessage && firstMessage.time,
        persona: persona,
        channels: channels,
        metadata: autoMessage && firstMessage ? {
          type: 'auto-message',
          campaign: _this.getCampaignForAutoMessage(firstMessage.message)
        } : undefined,
        type: firstMessage ? 'message' : 'event',
        key: idx + ":" + group.length + (lastItem ? ":" + lastItem.time.toISOString() : '')
      }, group.map(function (conversationItem) {
        return conversationItem.type === 'Message' ? React__default.createElement(Message, {
          message: conversationItem.message,
          nextMessage: _this.getNextMessage(conversationItem.message),
          enableReadReceipts: _this.props.enableReadReceipts,
          nextMessageBySameParticipant: _this.getNextMessageBySameParticipant(conversationItem.message),
          key: conversationItem.message.messageId
        }) : conversationItem.event.element;
      }));
    }));
  };

  return ExchangeContainer;
}(Component);

var Exchange = withChat(ExchangeContainer);

export default Exchange;
//# sourceMappingURL=index.js.map
